// @vue/component
import Add from "@/views/Investments/add.vue";
import Edit from "@/views/Investments/edit.vue";
import { Roles } from "../../utils/roles";

export default {
    name: "Investments",

    components: {
        Add,
        Edit,
        UserInfo: () => import("@/components/UserInfo.vue"),
    },

    mixins: [],

    props: {},

    data() {
        return {
            Roles,
            headers: [
                {
                    text: "المبلغ",
                    value: "amount",
                },
                {
                    text: "الملاحظات",
                    value: "notes",
                },
                {
                    text: "النوع",
                    value: "operationType",
                },
                {
                    text: "المستخدم",
                    value: "user",
                },
                {
                    text: "المستلم",
                    value: "receiverName",
                },
                {
                    text: "تاريخ العملية",
                    value: "transactionDate",
                },
                {
                    text: "آخر تحديث بواسطة",
                    value: "createdAt",
                },
                {
                    text: "",
                    value: "actions",
                    sortable: false,
                    align: "center",
                },
            ],
            show: false,
            loading: false,
            loadingUsers: false,
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            length: 0,
            lengthUsers: 0,
            searchDebounceTimer: null,
            operationTypeOptions: [
                {
                    text: "إيداع",
                    value: 1,
                },
                {
                    text: "سحب",
                    value: 2,
                },
                {
                    text: "أرباح",
                    value: 3,
                },
            ],
            filter: {
                pageIndex: 1,
                pageSize: 15,
                search: null,
                count: 0,
                investorId: null,
                operationTypes: [],
                transactionDateFrom: null,
                transactionDateTo: null,
            },
            filterUser: {
                pageIndex: 1,
                pageSize: 15,
                search: null,
                count: 0,
            },
            pageSizes: [5, 10, 15, 30, 50, 100],
            investments: [],
            users: [],
        };
    },

    computed: {},

    watch: {
        "filterUser.search": {
            handler: "handleSearchChange",
            deep: true,
        },
    },

    async created() {
        await this.getInvestments();
    },

    methods: {
        FormattedDate(dateStr) {
            const date = new Date(dateStr); // Your date object
            const formattedDate = new Intl.DateTimeFormat("en-SE", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false, // Use 24-hour format
            }).format(date);
            return formattedDate;
        },
        CleanFilterInvestor() {
            this.filterUser.search = null;
            this.filterUser.count = 0;
            this.filterUser.pageSize = 15;
            this.filterUser.pageIndex = 1;
            this.users = [];
        },
        async handleSearchChange(newSearch, oldSearch) {
            // This function will be called whenever the 'search' property changes
            // console.log(`Search changed from ${oldSearch} to ${newSearch}`);
            // Introduce a delay of 1 second (1000 milliseconds) using setTimeout
            setTimeout(async () => {
                await this.getUsers(
                    this.filterUser.pageIndex,
                    this.filterUser.pageSize,
                    newSearch
                );
                // Your logic here (e.g., make an API call or update component state)
                // console.log('Delayed action after 1.1 second');
            }, 1100);
        },
        async getUsers(pageIndex, pageSize, search) {
            this.loadingUsers = true;
            this.users = [];
            try {
                let queryUsers = `Users?IsDelete=false`;
                if (pageIndex !== undefined && pageIndex !== null) {
                    queryUsers = queryUsers + `&PageIndex=${pageIndex}`;
                }
                if (pageSize !== undefined && pageSize !== null) {
                    queryUsers = queryUsers + `&PageSize=${pageSize}`;
                }
                if (search !== undefined && search !== null) {
                    queryUsers += `&Search=${search}`;
                }
                const res = await this.$http.get(queryUsers);
                // console.log(res.data.result.data);
                this.users = res.data.result.data;
                this.filterUser.count = res.data.result.count;
                this.lengthUsers =
                    res.data.result.count === undefined
                        ? 0
                        : Math.ceil(
                              res.data.result.count / this.filterUser.pageSize
                          );
            } catch (err) {
                console.log(err);
                // service.faild(err.response.data.message);
            } finally {
                this.loadingUsers = false;
            }
            // console.log(this.users,this.filterUser);
        },

        onFiltersChanged(resetPage = true) {
            if (resetPage) {
                this.filter.pageIndex = 1;
            }
            this.getInvestments();
        },

        onPaginationChanged() {
            this.getInvestments();
        },

        handleGlobalSearchChange() {
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }

            this.searchDebounceTimer = setTimeout(() => {
                this.onFiltersChanged();
            }, 450);
        },

        buildInvestmentsQuery(pageIndex, pageSize) {
            const params = new URLSearchParams();
            params.append("IsDelete", "false");
            params.append("PageIndex", `${pageIndex}`);
            params.append("PageSize", `${pageSize}`);

            if (this.filter.search && this.filter.search.trim()) {
                params.append("Search", this.filter.search.trim());
            }

            if (this.filter.investorId) {
                params.append("InvestorId", this.filter.investorId);
            }

            if (
                Array.isArray(this.filter.operationTypes) &&
                this.filter.operationTypes.length > 0
            ) {
                params.append(
                    "OperationTypes",
                    this.filter.operationTypes.join(",")
                );
            }

            if (this.filter.transactionDateFrom) {
                params.append(
                    "TransactionDateFrom",
                    this.filter.transactionDateFrom
                );
            }

            if (this.filter.transactionDateTo) {
                params.append(
                    "TransactionDateTo",
                    this.filter.transactionDateTo
                );
            }

            return `/investments/Investments?${params.toString()}`;
        },

        async getInvestments(
            pageIndex = this.filter.pageIndex,
            pageSize = this.filter.pageSize
        ) {
            this.investments = [];
            this.loading = true;

            this.filter.pageIndex = pageIndex;
            this.filter.pageSize = pageSize;

            const query = this.buildInvestmentsQuery(pageIndex, pageSize);

            await this.$http
                .get(query)
                .then((response) => {
                    const invests = response.data.result.data;
                    this.investments = Array.isArray(invests) ? invests : [];
                    this.filter.count = response.data.result.count;
                    this.length =
                        response.data.result.count === undefined
                            ? 0
                            : Math.ceil(
                                  response.data.result.count /
                                      this.filter.pageSize
                              );
                })
                .catch((error) => {
                    this.$store.dispatch("toastification/setToast", {
                        message: `${
                            error?.response?.data?.message ||
                            "حدث خطأ أثناء تحميل البيانات"
                        }`,
                        type: "error",
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async updateInvestment(id, updatedData) {
            this.loading = true;
            try {
                const response = await this.$http.put(
                    `Investments/${id}`,
                    updatedData
                );

                this.showSuccess(
                    response.data.message || "تم تحديث الاستثمار بنجاح"
                );

                // Refresh the investments list
                await this.getInvestments();
            } catch (error) {
                console.error("Error updating investment:", error);
                this.handleApiError(error, "حدث خطأ أثناء تحديث الاستثمار");
            } finally {
                this.loading = false;
            }
        },

        async deleteItem(id, index) {
            this.$genericService.swalAlertConfirm({}).then((result) => {
                if (result.isConfirmed) {
                    this.loading = true;
                    this.$http
                        .delete(`Investments?id=` + id)
                        .then((res) => {
                            this.$store.dispatch("toastification/setToast", {
                                message: `تم حذف الاستثمار بنجاح`,
                                type: "success",
                            });
                            this.investments.splice(index, 1);
                        })
                        .catch((err) => {
                            this.$store.dispatch("toastification/setToast", {
                                message: `${err.response.data.message}`,
                                type: "error",
                            });
                        })
                        .finally(() => (this.loading = false));
                }
            });
        },
        async resetFilter() {
            this.$refs.filterForm.reset();
            this.CleanFilterInvestor();
            this.filter.pageIndex = 1;
            this.filter.search = null;
            this.filter.count = 0;
            this.filter.investorId = null;
            this.filter.operationTypes = [];
            this.filter.transactionDateFrom = null;
            this.filter.transactionDateTo = null;
            await this.getInvestments();
        },
        GetType(type) {
            if (type === 1) {
                return "إيداع";
            } else if (type === 2) {
                return "سحب";
            } else {
                return "أرباح";
            }
        },
    },
};
